import { Box, KeyboardShift, Text } from '@betty/moonlight';
import { memo, useCallback, useEffect } from 'react';
import { Screen, useFocusEffect, useNavigation } from '@betty/navigation';
import { useTranslation } from '@betty/i18n';
import PeriodInput from '../../components/ResponsibleGaming/components/PeriodInput/PeriodInput';
import { useDispatch } from '@betty/toolkit/state';
import { fetchLImits } from '../../components/ResponsibleGaming/state';

function DepositLimitScreen() {
  const dispatch = useDispatch();
  const { t } = useTranslation('responsibleGaming');
  const navigation = useNavigation();

  useEffect(() => {
    navigation.setOptions({ title: t('lossLimit') });
  }, [navigation, t]);

  useFocusEffect(
    useCallback(() => {
      dispatch(fetchLImits());
    }, [dispatch]),
  );

  return (
    <Screen>
      <KeyboardShift showsVerticalScrollIndicator={false} style={{ flex: 1 }}>
        <Box marginTop="space-400" gap="space-800">
          <Text
            variant="body-m-semi"
            locNS="responsibleGaming"
            locKey="lossLimitTitle"
            color="darkSurfacePrimary"
          />

          <Box gap="space-200">
            <Text
              variant="body-m-semi"
              locNS="responsibleGaming"
              locKey="example"
              color="darkSurfacePrimary"
            />
            <Text
              variant="body-m-semi"
              locNS="responsibleGaming"
              locKey="lossLimitExample"
              color="darkSurfacePrimary"
            />

            <PeriodInput type="Loss" />
          </Box>
        </Box>
      </KeyboardShift>
    </Screen>
  );
}

export default memo(DepositLimitScreen);
